import React from "react";
// import { Carousel } from "react-bootstrap";
// import { LoginCarouselData } from "../../../utils";
// import FallbackImage from "../../Common/ImageWrapper";
// import SwiperComp from "../../Common/SwiperComp";
import { TextInputComp } from "../../Ui";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { selectCurrentCompanyId } from "../../../store/auth/index.js";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { EnvironmentBadge } from "../../Common";

// Removed background image styles as they're no longer needed

export default function LoginPage({
  handleLoginSubmit,
  companyDetails,
  isLoading,
}) {
  const navigate = useNavigate();
  // const PageSideStyle = styled.div`
  //   z-index: 3;
  //   height: 100% !important;
  // `;
  // fetch the company Id
  const coopId = useSelector(selectCurrentCompanyId);
  const initialValues = {
    email: "",
    password: "",
    company_id: coopId,
  };

  // Yup validations schema
  const validationSchema = Yup.object({
    email: Yup.string().email().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  /*
  const PageSide = (item) => {
    return (
      <PageSideStyle className="position-relative bg-white text-black h-100">
        <div className="d-none d-md-flex" style={{ height: "40vh" }}>
          <FallbackImage src="/Login/top.png" width={246} height={246} />
        </div>
        <div className="mb-md-5 pb-5 container col-lg-10">
          <h1 className="text-center fw-bolder h10 col-md-11 mb-md-4 ">
            {item?.title}
          </h1>
          <p className="text-start d-none d-lg-block lh-lg">{item?.desc}</p>
          <p className="text-center  d-md-none">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur
            nunc, erat auctor commodo eu nu
          </p>
        </div>
        <div className="py-md-5 my-md-5"></div>
        <div className="d-none d-md-flex align-items-end position-absolute bottom-0 w-100">
          <FallbackImage src="/Login/bottom.svg" width={"100%"} />
        </div>
        <div className="d-flex justify-content-center"></div>
      </PageSideStyle>
    );
  };
  */

  return (
    <>
      <div className="Login">
        {/* Environment Badge - Toggle switch style (read-only) */}
        <EnvironmentBadge variant="corner" />
        
        <div
          className="min-h-screen flex items-center justify-center px-4 relative"
          style={{
            background:
              'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("/login-background.png")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
          }}
        >
          <div className="w-full max-w-md relative z-10">
            {/* Logo and Welcome Section */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4 shadow-lg">
                <svg
                  className="w-10 h-10 text-[#8B313A]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h1 className="text-3xl font-bold text-white mb-2 drop-shadow-lg">
                Uniquecoop Manager Dashboard
              </h1>
              <p className="text-gray-200 drop-shadow-md">
                Welcome back! Please sign in to continue
              </p>
            </div>

            {/* Login Form */}
            <div className="bg-white rounded-2xl shadow-2xl p-8 backdrop-blur-sm bg-opacity-95 relative">
              {/* Environment Badge - Also inside login card for extra visibility */}
              <div className="absolute -top-4 right-6">
                <div className="bg-white rounded-lg px-3 py-2 shadow-lg">
                  <EnvironmentBadge variant="inline" />
                </div>
              </div>
              
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  Welcome ✨
                </h2>
                <p className="text-gray-600">
                  Sign in with your credentials to experience seamless
                  cooperative activities
                </p>
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleLoginSubmit}
              >
                <Form>
                  <div className="mb-4">
                    <TextInputComp
                      LabelClassName={"fw-normal text-gray-700"}
                      borderColor={"#A1A0A0"}
                      borderWidth="1px"
                      InputClassName={
                        "border !border-1 py-3 px-4 rounded-lg focus:ring-2 focus:ring-[#8B313A] focus:border-transparent"
                      }
                      labelText={"Email Address"}
                      placeholder="Enter Email Address"
                      name="email"
                      type="text"
                    />
                  </div>
                  <div className="mb-4">
                    <TextInputComp
                      LabelClassName={"fw-normal text-gray-700"}
                      borderColor={"#A1A0A0"}
                      borderWidth="1px"
                      InputClassName={
                        "border border-1 py-3 px-4 rounded-lg focus:ring-2 focus:ring-[#8B313A] focus:border-transparent"
                      }
                      labelText={"Password"}
                      placeholder="Enter Password"
                      name="password"
                      type="password"
                    />
                  </div>
                  <div
                    onClick={() => navigate("/forget_password")}
                    className="text-right text-sm text-[#8B313A] hover:text-red-700 cursor-pointer mb-6"
                  >
                    Forget password?
                  </div>
                  <div className="mb-6">
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full bg-[#8B313A] text-white border-0 py-3 rounded-lg font-bold hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center justify-center"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                          Logging in...
                        </>
                      ) : (
                        "Login"
                      )}
                    </button>
                  </div>

                  <div className="text-center">
                    <span className="text-gray-600">
                      Don't have an account?{" "}
                      <span className="text-[#8B313A] font-medium cursor-pointer hover:text-red-700">
                        Sign up
                      </span>
                    </span>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
